module.exports = __webpack_public_path__ + "img/500-bg-top-mobile.c7110c1.png";